export default __webpack_public_path__ + "static/media/emailEnviado.0b614b3d.svg";